import { SocketClient } from "cbcore-ts"
import { UIColor, UIView } from "uicore-ts"


export class BottomBarView extends UIView {
    
    //label: UITextView;
    
    constructor(elementID: string) {
        
        super(elementID)
    
        this.backgroundColor = UIColor.colorWithRGBA(50, 50, 50)
        
        this.setInnerHTML("bottomBarContent", "bottomBarContent", { UPDATE_TIME_STRING: "" })
        
        this.loadUpdateTimeString()
        
        // this.label = new UITextView("BottomBarLabel");
        // this.label.setText("bottomBarLabelText","Bottom bar for contact information and such");
        // this.label.textColor = UIColor.whiteColor;
        // this.label.textAlignment = UITextView.textAlignment.center;
    
        // this.addSubview(this.label);
        
    }
    
    
    async loadUpdateTimeString() {
        
        const date = new Date(
            (await SocketClient.RetrieveLastUpdateTimestamp()).result
        )
        
        const day = String(date.getDate()).padStart(2, "0")
        const month = String(date.getMonth() + 1).padStart(2, "0") // months are 0-based  
        const year = date.getFullYear()
        
        const hours = String(date.getHours()).padStart(2, "0")
        const minutes = String(date.getMinutes()).padStart(2, "0")
        
        const formattedString = `${day}-${month}-${year} ${hours}:${minutes}`
        
        this.setInnerHTML(
            "bottomBarContent",
            "bottomBarContent",
            { UPDATE_TIME_STRING: "<br>\n Andmed viimati uuendatud: " + formattedString }
        )
        
        
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        //this.label.centerInContainer();
        
    }
    
}
























